import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {RGBA} from '@Utils/color.util';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

export function LayoutHighlightedBackgroundOpacityOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const highlightedBackgroundColor = useGetKeyFromTableItem('highlightedBackgroundColor');

  if (!activeItem || (activeItem && !('highlightedBackgroundColor' in activeItem)) || !highlightedBackgroundColor) {
    throw new Error('Item does not have highlightedBackgroundColor property');
  }

  const updateOpacity = (highlightedBackgroundColorAlpha: number, undoable = true): void => {
    const highlightedBgColor = highlightedBackgroundColor.slice() as RGBA;
    highlightedBgColor[3] = highlightedBackgroundColorAlpha;
    void activeItem.updateFromObject(
      {
        highlightedBackgroundColor: highlightedBgColor,
      },
      {
        undoable,
      }
    );
  };

  const onChangeHandler = (updatedValue: number): void => {
    updateOpacity(updatedValue, false);
  };

  const onChangeEnded = (updatedValue: number): void => {
    updateOpacity(updatedValue);
  };

  return (
    <ContextualMenuSliderOptions
      id="highlighted-background-color-alpha-option"
      value={highlightedBackgroundColor[3]}
      label={window.i18next.t('pmwjs_opacity')}
      range={{
        min: 0,
        max: 1,
      }}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEnded}
    />
  );
}
